export const OPEN_DELETE_BATCH_MODAL = 'OPEN_DELETE_BATCH_MODAL';
export const CLOSE_DELETE_BATCH_MODAL = 'CLOSE_DELETE_BATCH_MODAL';

function openDeleteBatchModal(batchToDelete) {
  return {
    type: OPEN_DELETE_BATCH_MODAL,
    isDeleteBatchModalShown: true,
    batchToDelete
  };
}

function closeDeleteBatchModal() {
  return {
    type: CLOSE_DELETE_BATCH_MODAL,
    isDeleteBatchModalShown: false,
    deleteBatchResponse: null,
    deleteBatchError: null
  };
}

export function showDeleteBatchModal(batchToDelete) {
  return (dispatch) => {
    dispatch(openDeleteBatchModal(batchToDelete));
  };
}

export function hideDeleteBatchModal() {
  return (dispatch) => {
    dispatch(closeDeleteBatchModal());
  };
}
